import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const lumos = defineConnector({
  identifier: "lumos",
  name: "Lumos",
  tagLine: "IT access management",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://api\\.lumos\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiToken),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In Lumos, go to **Settings → API Tokens** and click **+ Add**. Select **API Token** for cloud-based tenants or **On Prem Agent Token** for on-prem. Name your token and click **Add**.",
        },
      ],
    },
    {
      title: "Paste your API token",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.lumos.com/health",
  },
});
